import { useState, useEffect, useRef } from "react";
import TabbedPanel from "../../../components/common/tabbedPanel";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import CampignLeadCardInfo from "../../../components/campaign/LeadCardInfo/CampignLeadCardInfo";
import {
  useCampaignChangeStatusQuery,
  useCampainPaginationQuery,
  useCampignWorkflowQuery,
} from "../../../Services/campign/campignList";
import { useDetailCamapignQuery } from "../../../Services/campign/CampaignDetail";
import { useTaskQuery } from "../../../Services/ticket/Task";
import ReactModal from "react-modal";
import CreateTask from "./CreateTask";
import { useWebSocket } from "../../../context/WebSocketContext";
import { toast } from "react-toastify";
import CampaignLeadModel from "../CampaignLeadModel";
import { useAddContactMutation } from "../../../Services/customer/FrontendCustomer";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { useLeadTrailDataQuery } from "../../../Services/lead/Lead";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import AssignmentIcon from "@mui/icons-material/Assignment";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import GroupIcon from "@mui/icons-material/Group";
import "../../ticket/ticketLists/TicketListInfo.scss";

// src/pages/ticket/ticketLists/TicketListInfo.scss

const LeadInfo = () => {
  const params = useParams();
  const uuid = params.uuid;

  const [currentLeadId, setCurrentCamapignId] = useState(uuid);
  const {
    data,
    refetch,
    status: campaignStatus,
  } = useDetailCamapignQuery(currentLeadId);
  const { data: leadTrailData, refetch: refetchLeadTrail } =
    useLeadTrailDataQuery(uuid);

  const [isStatusWonSelected, setIsStatusWonSelected] = useState("");
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isNotificationModalOpen, setIsNotificationModalOpen] = useState(false);
  const [socketData, setSocketData] = useState({});
  const [liftingTaskData, setLiftingTaskData] = useState("");
  const [isCreateTaskModalOpen, setIsCreateTaskModalOpen] = useState(false);
  const [isKnowledgeBaseModalOpen, setIsKnowledgeBaseModalOpen] = useState(false);
  const [isOurTeamModalOpen, setIsOurTeamModalOpen] = useState(false);

  const [getAllStatus, setGetAllStatus] = useState<any>([]);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [trigger] = useAddContactMutation();
  const selectedOption = sessionStorage.getItem("selectedOptionCampign") || "campaignListView";
  const campaignListViewPageSize = sessionStorage.getItem("campaignListViewPageSize") || "5";
  const campaignListCardViewPageSize = sessionStorage.getItem("campaignListCardViewPageSize") || "5";
  const campaignCardViewPageSize = sessionStorage.getItem("campaignCardViewPageSize") || "5";
  const {
    data: taskData,
    refetch: refetchTask,
    isLoading,
  } = useTaskQuery(currentLeadId);
  const { data: campaignData, refetch: refetchAuditTrailData } =
    useCampaignChangeStatusQuery(data?.campaign?.id, {
      skip: !data?.campaign?.id,
    });
  const [isAddNewLeadModalOpen, setIsAddNewLeadModalOpen] = useState(false);
  const [liftingObj, setLiftingObj] = useState({});

  const navigate = useNavigate();
  const routerLocation = useLocation();

  const closeModal = () => {
    setIsModalOpen(false);
    setIsCreateTaskModalOpen(false);
    setIsNotificationModalOpen(false);
  };

  const handleBackButtonClick = () => {
    navigate(-1);
  };

  const openContactModal = async () => {
    setButtonClicked(true);

    try {
      const response = await trigger(liftingObj);

      if (response?.data) {
        toast.success("Added successfully");
        closeModal();
      } else if (response?.error) {
        const error = response.error as {
          data?: { email?: string[]; name?: string[] };
        };
        const errorEmail = error?.data?.email?.[0];
        const errorName = error?.data?.name?.[0];
        const errorMessage = errorEmail
          ? "Email shall not be blank"
          : errorName
            ? "Name shall not be blank"
            : "";
        toast.error(errorMessage);
        setButtonClicked(false);
      }
    } catch (error) {
      toast.error("An unexpected error occurred");
      setButtonClicked(false);
    }
  };

  const openLeadModal = () => {
    setIsAddNewLeadModalOpen(true);
  };

  const closeContactModal = () => {
    setIsAddNewLeadModalOpen(false);
  };

  const [isBulk, setIsBulk] = useState(false);
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState<any>(() => {
    const savedPage = sessionStorage.getItem("campaignCurrentPage");
    const parsedPage = Number(savedPage);
    return isNaN(parsedPage) || parsedPage < 1 ? 1 : parsedPage;
  });
  const [campaignId, setCampaignId] = useState(
    sessionStorage.getItem("selectedCampaignId") || ""
  );

  const [liftUiData, setLiftUiData] = useState(0);
  const [liftingKey, setLiftingKey] = useState([]);
  const [storeKey, setStoreKey] = useState(liftUiData ? "active" : "All");
  const [paneOpen, setPaneOpen] = useState<String>("LeadInformationTab");

  /** Open Tasks tab when navigating from Lead dashboard task-status drill-down (TableModal "Lead task") */
  useEffect(() => {
    const st = routerLocation.state as { initialPane?: string } | null | undefined;
    if (st?.initialPane === "TasksTab") {
      setPaneOpen("TasksTab");
    }
  }, [routerLocation.key]);

  const workflowName = localStorage.getItem("workflowName");
  const campaignnId = localStorage.getItem("campaignId");

  const [selectedFilterAndValue1, setSelectedFilterAndValue1] = useState<any>(
    () => {
      const sessionData = sessionStorage.getItem(
        "selectedCampaignFilterAndValue"
      );
      return sessionData
        ? JSON.parse(sessionData)
        : {
          email__icontains: "",
          assignee__username__icontains: "",
          account_name__icontains: "",
          created: "",
          first_name__icontains: "",
          last_name__icontains: "",
          phone_number__icontains: "",
        };
    }
  );

  const { data: CampaignWorkflow, refetch: refetchWorkflow } =
    useCampignWorkflowQuery(
      {
        selectedWorkFlow: workflowName,
        selectCampaign: campaignnId,
        selectedFilterAndValue1,
      },
      { skip: !campaignnId || !workflowName }
    );

  const [selectedTeamId, setSelectedTeamId] = useState(() => {
    const selectedTeamIdFromSession = sessionStorage.getItem("selectedTeamId");
    const userRole = localStorage.getItem("user_role");
    const userId = localStorage.getItem("circleone-username");

    if (selectedTeamIdFromSession) {
      return selectedTeamIdFromSession;
    }

    if (userRole === "admin") {
      return "My Team";
    }

    if (userRole === "agent" || userRole === "manager") {
      return userId;
    }

    return null;
  });

  const [value, setValue] = useState(liftUiData ? "active" : "All");
  const [direction, setDirection] = useState(null);
  const [pageChangeDirection, setPageChangeDirection] = useState<"next" | "previous" | null>(null);
  const [isTicketLoading, setIsTicketLoading] = useState(false);

  const customResetPassModalStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "450px",
      maxWidth: "850px",
      margin: "auto",
      maxHeight: "600px",
      OverflowY: "auto",
    },
  };

  const socket = useWebSocket();

  const leadInformationRef = useRef<HTMLDivElement>(null);

  const scrollToTop = () => {
    if (leadInformationRef.current) {
      leadInformationRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    const serverResponse = socket?.state?.serverResponse?.[0]?.data;

    if (serverResponse) {
      setIsNotificationModalOpen(true);
      setSocketData(serverResponse);
    }
  }, [socket, socket?.state?.serverResponse]);

  const [loading, setLoading] = useState(false);
  const { data: fetchedData, refetch: refetchPagination } =
    useCampainPaginationQuery(
      {
        currentPage,
        selectCampaign: campaignId,
        value,
        liftingKey,
        storeKey,
        selectedFilterAndValue1,
        selectedTeamId,
        pageSize: selectedOption === "campaignListView" ? campaignListViewPageSize : selectedOption === "campaignListCardView" ? campaignListCardViewPageSize : campaignCardViewPageSize,
      },
      { skip: !campaignId }
    );

  useEffect(() => {
    if (campaignStatus === "pending") {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [campaignStatus]);

  const handleButtonClick = async (event, direction) => {
    event.preventDefault();
    setDirection(direction);
    setIsTicketLoading(true);
    const recordsPerPage: any =
      selectedOption === "campaignListView"
        ? campaignListViewPageSize
        : selectedOption === "campaignListCardView"
          ? campaignListCardViewPageSize
          : campaignCardViewPageSize;
    const camapignLead = fetchedData?.results;
    const totalRecords = fetchedData?.count || 0;
    const totalPages = Math.ceil(totalRecords / recordsPerPage);
    const currentIndex = camapignLead?.findIndex(
      (camapign) => camapign.id === currentLeadId
    );

    let isPageChange = false;

    if (direction === "next") {
      if (currentIndex < camapignLead?.length - 1) {
        const nextLeadId = camapignLead[currentIndex + 1].id;
        setCurrentCamapignId(nextLeadId);
        navigate(`/campaign/lead/${nextLeadId}`, {
          replace: true,
        });
        setConfirmationModalOpen(false);
      } else if (currentPage < totalPages) {
        const newPage = currentPage + 1;
        sessionStorage.setItem("campaignCurrentPage", String(newPage));
        setCurrentPage(newPage);
        setPageChangeDirection("next");
        isPageChange = true;
        setConfirmationModalOpen(false);
      } else {
        toast.warning("No more leads available.");
        setConfirmationModalOpen(false);
      }
    } else if (direction === "previous") {
      if (currentIndex > 0) {
        const previousLeadId = camapignLead[currentIndex - 1]?.id;
        setCurrentCamapignId(previousLeadId);
        navigate(`/campaign/lead/${previousLeadId}`, {
          replace: true,
        });
      } else if (currentPage > 1) {
        const newPage = currentPage - 1;
        sessionStorage.setItem("campaignCurrentPage", String(newPage));
        setCurrentPage(newPage);
        setPageChangeDirection("previous");
        isPageChange = true;
      } else {
        toast.warning("No previous leads available.");
      }
    }

    if (!isPageChange) {
      setIsTicketLoading(false);
    }
  };

  useEffect(() => {
    if (!pageChangeDirection) return;

    const runPageChange = async () => {
      setIsTicketLoading(true);
      try {
        const result = await refetchPagination();
        const newData = result?.data;
        if (newData?.results?.length > 0) {
          const leadId =
            pageChangeDirection === "next"
              ? newData.results[0].id
              : newData.results[newData.results.length - 1].id;
          setCurrentCamapignId(leadId);
          navigate(`/campaign/lead/${leadId}`, { replace: true });
          setPaneOpen("LeadInformationTab");
          setConfirmationModalOpen(false);
        }
      } finally {
        setPageChangeDirection(null);
        setIsTicketLoading(false);
      }
    };

    runPageChange();
  }, [currentPage, pageChangeDirection]);

  const customModalStyles12 = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "100%",
      maxWidth: "850px",
      height: "70%",
      margin: "auto",
      Overflow: "hidden",
      OverflowY: "auto",
    },
  };

  const customModalStyle = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "100%",
      maxWidth: "550px",
      maxHeight: "450px",
      margin: "auto",
      Overflow: "hidden",
      OverflowY: "auto",
    },
  };

  useEffect(() => {
    const refetchData = async () => {
      setIsTicketLoading(true);
      await refetchPagination();

      if (direction === "next" || direction === "previous") {
        setPaneOpen("LeadInformationTab");
      }

      setIsTicketLoading(false);
      setDirection(null);
    };

    if (direction) {
      setPaneOpen("LeadInformationTab");
      refetchData();
    }
  }, [direction]);

  const handleCreateTask = () => {
    const assigneeName = localStorage.getItem("assigneeName");
    if (assigneeName === null || assigneeName === "Unassigned") {
      toast.error("Assign the lead first");
    } else {
      setIsCreateTaskModalOpen(true);
    }
  };

  return (
    <>
      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "100vh" }}
        >
          <LoadingSpinner />
        </div>
      ) : (
        <div className="ticket-list-info-container" ref={leadInformationRef}>
          <div className="ticket-info-wrapper">
            <div className="ticket-info-header">
              <div className="header-left">
                <button className="back-button" onClick={handleBackButtonClick}>
                  <ArrowBackIcon />
                </button>
                <h2 className="page-title">Campaign information</h2>
              </div>

              <div className="header-right">
                {/* <button
                  className="action-button knowledge-base-btn"
                  onClick={() => setIsKnowledgeBaseModalOpen(true)}
                  disabled
                  style={{ opacity: 0.5, cursor: "not-allowed" }}
                >
                  <MenuBookIcon fontSize="small" />
                  <span>Knowledge base</span>
                </button>
                <button
                  className="action-button our-team-btn"
                  onClick={() => setIsOurTeamModalOpen(true)}
                  disabled
                  style={{ opacity: 0.5, cursor: "not-allowed" }}
                >
                  <GroupIcon fontSize="small" />
                  <span>Our team</span>
                </button> */}
                <button className="action-button" onClick={openLeadModal}>
                  <AddIcon fontSize="small" />
                  <span>Lead</span>
                </button>
                <button className="action-button" onClick={openContactModal}>
                  <PersonAddIcon fontSize="small" />
                  <span>Contact</span>
                </button>
                <button
                  className="create-task-button"
                  onClick={handleCreateTask}
                >
                  <AssignmentIcon fontSize="small" />
                  Create task
                </button>
              </div>
            </div>

            <div className="navigation-controls">
              <button
                className="nav-button"
                onClick={(event) => handleButtonClick(event, "previous")}
                title="Previous Lead"
              >
                <ArrowBackIosIcon fontSize="small" />
              </button>
              <button
                className="nav-button"
                onClick={(event) => handleButtonClick(event, "next")}
                title="Next Lead"
              >
                <ArrowForwardIosIcon fontSize="small" />
              </button>
            </div>

            <ReactModal
              isOpen={isAddNewLeadModalOpen}
              onRequestClose={closeContactModal}
              style={!isBulk ? customModalStyles12 : customModalStyle}
              contentLabel="Lead"
              shouldCloseOnOverlayClick={false}
            >
              <CampaignLeadModel
                closeModal={closeContactModal}
                isBulk={isBulk}
                setIsBulk={setIsBulk}
                refetchWorkflow={refetchWorkflow}
                refetch={refetch}
                campaignId={campaignId}
                value={value}
                setValue={setValue}
                setStoreKey={setStoreKey}
                selectedCampaign={campaignData?.results[0]?.campaign}
              />
            </ReactModal>

            <ReactModal
              isOpen={isCreateTaskModalOpen}
              onRequestClose={closeModal}
              style={customResetPassModalStyles}
              contentLabel="Create Task"
              shouldCloseOnOverlayClick={false}
            >
              <CreateTask taskInfo={data} close={closeModal} />
            </ReactModal>

            {/* Knowledge Base Modal Placeholder */}
            <ReactModal
              isOpen={isKnowledgeBaseModalOpen}
              onRequestClose={() => setIsKnowledgeBaseModalOpen(false)}
              style={customResetPassModalStyles}
              contentLabel="Knowledge Base"
              shouldCloseOnOverlayClick={false}
            >
              <div className="placeholder-modal">
                <div className="modal-header-placeholder">
                  <h2 className="modal-title">Knowledge Base</h2>
                  <button
                    className="close-button-placeholder"
                    onClick={() => setIsKnowledgeBaseModalOpen(false)}
                  >
                    ×
                  </button>
                </div>
                <div className="modal-content-placeholder">
                  <p>Knowledge base content coming soon...</p>
                </div>
                <div className="modal-footer-placeholder">
                  <button
                    className="btn-primary"
                    onClick={() => setIsKnowledgeBaseModalOpen(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </ReactModal>

            {/* Our Team Modal Placeholder */}
            <ReactModal
              isOpen={isOurTeamModalOpen}
              onRequestClose={() => setIsOurTeamModalOpen(false)}
              style={customResetPassModalStyles}
              contentLabel="Our Team"
              shouldCloseOnOverlayClick={false}
            >
              <div className="placeholder-modal">
                <div className="modal-header-placeholder">
                  <h2 className="modal-title">Our Team</h2>
                  <button
                    className="close-button-placeholder"
                    onClick={() => setIsOurTeamModalOpen(false)}
                  >
                    ×
                  </button>
                </div>
                <div className="modal-content-placeholder">
                  <p>Team information coming soon...</p>
                </div>
                <div className="modal-footer-placeholder">
                  <button
                    className="btn-primary"
                    onClick={() => setIsOurTeamModalOpen(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </ReactModal>

            {isTicketLoading ? (
              <div className="loading-container">
                <LoadingSpinner />
              </div>
            ) : data?.length === 0 ? (
              <div className="no-data">No data available.</div>
            ) : (
              <div className="ticket-content-layout" style={{ gridTemplateColumns: '1fr' }}>
                <div className="main-contentttt">
                  <CampignLeadCardInfo
                    campign={data}
                    refetch={refetch}
                    refetchAuditTrailData={refetchAuditTrailData}
                    setGetAllStatus={setGetAllStatus}
                    loading={loading}
                    liftingObj={liftingObj}
                    setIsStatusWonSelected={setIsStatusWonSelected}
                    isStatusWonSelected={isStatusWonSelected}
                  />
                  <TabbedPanel
                    tickets={data}
                    refetch={refetch}
                    taskData={taskData}
                    refetchTask={refetchTask}
                    isLoading={isLoading}
                    setLiftingTaskData={setLiftingTaskData}
                    handleButtonClick={handleButtonClick}
                    setConfirmationModalOpen={setConfirmationModalOpen}
                    confirmationModalOpen={confirmationModalOpen}
                    setLiftingObj={setLiftingObj}
                    buttonClicked={buttonClicked}
                    scrollToTop={scrollToTop}
                    setPaneOpen={setPaneOpen}
                    paneOpen={paneOpen}
                    setIsStatusWonSelected={setIsStatusWonSelected}
                    isStatusWonSelected={isStatusWonSelected}
                    leadTrailData={leadTrailData}
                    refetchLeadTrail={refetchLeadTrail}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default LeadInfo;